/**
 * b2b-api writes a `.webp` copy next to every uploaded logo and banner, but
 * still returns the original URL because recruitment emails link to it. GIFs
 * keep their animation and data URLs their payload, so both are left as is.
 */
export const toWebpUrl = (url: string | undefined): string => {
  if (!url) {
    return '';
  }

  if (url.startsWith('data:')) {
    return url;
  }

  const queryStart = url.search(/[?#]/);
  const pathEnd = queryStart === -1 ? url.length : queryStart;
  const path = url.slice(0, pathEnd);
  const fileStart = path.lastIndexOf('/') + 1;

  if (fileStart === path.length) {
    return url;
  }

  const dotIndex = path.lastIndexOf('.');
  const hasExtension = dotIndex >= fileStart;

  if (hasExtension && path.slice(dotIndex + 1).toLowerCase() === 'gif') {
    return url;
  }

  const base = hasExtension ? path.slice(0, dotIndex) : path;
  return `${base}.webp${url.slice(pathEnd)}`;
};
